



























import { MukoFlg } from '@/constants/constants';
import Vue from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  name: 'CtrlRadioMukoFlg',
  props: {
    value: {
      type: Number,
    },
    disabled: {
      type: Boolean,
    },
  },
  data: () => ({
    MukoFlg,
  }),
  methods: {
    handleChange(value: any) {
      this.$emit('change', value);
    },
  },
});
